import { Component, Input } from '@angular/core';

import { AiMessage as AiMessageModel } from '../../../core/services/ai-agents';

@Component({
  selector: 'app-ai-message',
  standalone: false,
  templateUrl: './ai-message.html',
  styleUrl: './ai-message.scss',
})
export class AiMessage {
  @Input({ required: true }) message!: AiMessageModel;
  @Input() compact = false;
}
